import { createSelector } from 'reselect';

const getSelectedConversationId = (state) => (state.conversation ? state.conversation.selectedConversationId : null);
const getUI = (state) => state.ui;

export const getConversationRatingData = createSelector(
  [getSelectedConversationId, getUI],
  (selectedConversationId, ui) => ui.conversationRatings[selectedConversationId]
);
